import StateOffcanvas from '../Offcanvas'
import { GroupSelect } from 'GroupSelect'
import { useSettings } from 'Settings'

const voltage_options = {
	"MAX" : [
		{ value : 1.32, label : 1.32 },
		{ value : 1.705, label : 1.705 },
		{ value : 1.815, label : 1.815 },
		{ value : 1.98, label : 1.98 },
		{ value : 2.2, label : 2.2 },
		{ value : 2.42, label : 2.42 },
		{ value : 2.64, label : 2.64 },
		{ value : 2.86, label : 2.86 }
	],
	"TYP" : [
		{ value : 1.2, label: 1.2 },
		{ value : 1.55, label: 1.55 },
		{ value : 1.65, label: 1.65 },
		{ value : 1.8, label: 1.8 },
		{ value : 2, label: 2 },
		{ value : 2.2, label: 2.2 },
		{ value : 2.4, label: 2.4 },
		{ value : 2.6, label: 2.6 },
	],
	"MIN" : [
		{ value : 1.08, label : 1.08 },
		{ value : 1.395, label : 1.395 },
		{ value : 1.485, label : 1.485 },
		{ value : 1.62, label : 1.62 },
		{ value : 1.8, label : 1.8 },
		{ value : 1.98, label : 1.98 },
		{ value : 2.16, label : 2.16 },
		{ value : 2.34, label : 2.34 }
	],
}


export function RedPanel({ handle, onHide }) {
	const [settings] = useSettings()
	const ldo = settings['ldo levels']

	return (
		<StateOffcanvas handle={handle} onHide={onHide} trigger="red" title="LDO Settings">
			<GroupSelect
				name="ULP LDO"
				unit="V"
				options={voltage_options[ldo['v_ulp_ldo_acc'].value]}
				value={ldo['v_ulp_ldo'].value}
				onChange={(v) => ldo['v_ulp_ldo'].setValue(v.value)}
			/>
			<GroupSelect
				name="LDO"
				unit="V"
				options={voltage_options[ldo['v_aux_ldo_acc'].value]}
				value={ldo['v_aux_ldo'].value}
				onChange={(v) => ldo['v_aux_ldo'].setValue(v.value)}
			/>
		</StateOffcanvas>
	)
}
